import {CubeOrder, Shop} from "../types";
import * as React from "react";
import {useState} from "react";
import {OrderTable} from "./OrderTable";
import {useAsyncEffect, usePlatform} from "@variocube/cube-ui";
import {adjustOrderState} from "./order";

export interface OrderTabProps {
    shop: Shop;
    onOpen: (cubeOrder: CubeOrder) => void;
}

export function OrderTab({shop, onOpen}: OrderTabProps) {
    const platform = usePlatform();
    const [orders, setOrders] = useState<CubeOrder[]>([]);

    useAsyncEffect(async () => {
        const occupancies = await platform.getOccupancies();
        setOrders(shop.orders.map(order => {
            const occupancy = occupancies.filter(occupancy => occupancy.content.order?.id == order.id).pop();
            return {
                order: {...order, orderState: adjustOrderState(order.orderState, !!occupancy)},
                occupancy,
            }
        }));
    }, [platform, shop]);

    return <OrderTable orders={orders} onClick={onOpen}/>;
}